import React from "react"

export default function FieldColor_InlineValueEmpty(props:any) {
    return (
        <React.Fragment>
            <div className="ui5-field-dropdown-inline-editable" onClick={props.onClick}>
                <div className="ui5-color-picker empty"/>
            </div>

            {props.children}
        </React.Fragment>
    )
}
